const usuario_listar = {
	name: "usuario-listar",
	path: "/usuarios",
	component: () =>
		import("@/views/usuario/usuario_listar/Usuarios.vue"),
	meta: {
		// # TODO adicionar permissao correta
		rule: ["autenticadosuperuser"]
	}
};

const empresa_usuarios = {
	name: "empresa-usuarios",
	path: "/empresas/:empresaPk/usuarios",
	component: () =>
		import("@/views/usuario/usuario_listar/Usuarios.vue"),
	meta: {
		// # TODO adicionar permissao correta
		rule: ["autenticadosuperuser", "colaboradoradicionar"]
	}
};

export default [
	usuario_listar,
	empresa_usuarios
];
